import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=27f6a1e7&scoped=true&"
import script from "./MainBanner.vue?vue&type=script&lang=js&"
export * from "./MainBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6a1e7",
  null
  
)

export default component.exports